import BaseService from './BaseService'

class VoucherService extends BaseService {
  constructor () {
    super({path: 'vouchers'})
  }
}

export default new VoucherService()
